<template>
  <form id="FormularioInvitado" class="columns is-multiline" @submit.prevent="sendForm">
    <b-field class="column is-12" label="Nombre *" label-position="horizontal">
      <b-input v-model="form.nombre" type="text" required></b-input>
    </b-field>

    <b-button class="is-success" type="submit" native-type="submit" label="Guardar" expanded></b-button>
  </form>
</template>

<script>
import { mapActions } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'InvitadoForm',
  props: {
    datavalues: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      form: {},
      initialFormState: {
        id: null,
        nombre: '',
      },
    };
  },
  watch: {
    datavalues: {
      immediate: true,
      handler(newData) {
        this.loadFormData(newData);
      },
    },
  },
  methods: {
    ...mapActions({
      submitForm: 'externalTurns/submitForm',
    }),
    loadFormData(newData) {
      if (newData && Object.keys(newData).length) {
        Object.keys(this.initialFormState).forEach((key) => {
          this.form[key] = newData[key] ?? this.initialFormState[key];
        });
      } else {
        this.form = { ...this.initialFormState };
      }
    },
    async sendForm() {
      const payload = { ...this.form };

      const response = await this.submitForm(payload);

      Swal.fire({
        icon: response.status ? 'success' : 'error',
        title: response.message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: true,
      });

      if (response.status) {
        this.$emit('close-form');
        this.$store.commit('externalTurns/SET_DATA', { key: 'reloadList', data: true });
      }
    },
  },
};
</script>

<style scoped>
.form-horizontal {
  max-width: 600px;
  margin: auto;
}
</style>
